var map = {
	"./account/Automations": [
		"b277",
		"chunk-5e481a3f"
	],
	"./account/Automations.vue": [
		"b277",
		"chunk-5e481a3f"
	],
	"./account/CampaignManager": [
		"1184",
		"chunk-24bd3634"
	],
	"./account/CampaignManager.vue": [
		"1184",
		"chunk-24bd3634"
	],
	"./account/Campaigns": [
		"ed4e",
		"chunk-ede859a2"
	],
	"./account/Campaigns.vue": [
		"ed4e",
		"chunk-ede859a2"
	],
	"./account/Companies": [
		"9c2f",
		"chunk-437b0038"
	],
	"./account/Companies.vue": [
		"9c2f",
		"chunk-437b0038"
	],
	"./account/Layouts": [
		"a250",
		"chunk-31020014"
	],
	"./account/Layouts.vue": [
		"a250",
		"chunk-31020014"
	],
	"./account/Promotions": [
		"67da",
		"chunk-4138d4eb"
	],
	"./account/Promotions.vue": [
		"67da",
		"chunk-4138d4eb"
	],
	"./account/Settings": [
		"c1e5c",
		"chunk-7b5a561e"
	],
	"./account/Settings.vue": [
		"c1e5c",
		"chunk-7b5a561e"
	],
	"./account/SmsMarketing": [
		"0887",
		"chunk-2750a38a"
	],
	"./account/SmsMarketing.vue": [
		"0887",
		"chunk-2750a38a"
	],
	"./account/Stores": [
		"9775",
		"chunk-ce9fcf8c"
	],
	"./account/Stores.vue": [
		"9775",
		"chunk-ce9fcf8c"
	],
	"./account/TextToBuy": [
		"cfaf",
		"chunk-0876e74c"
	],
	"./account/TextToBuy.vue": [
		"cfaf",
		"chunk-0876e74c"
	],
	"./account/components": [
		"ef2b",
		"chunk-5bd3a8c3"
	],
	"./account/components/": [
		"ef2b",
		"chunk-5bd3a8c3"
	],
	"./account/components/AttachRuleModal": [
		"91ee",
		"chunk-ce949eb8"
	],
	"./account/components/AttachRuleModal.vue": [
		"91ee",
		"chunk-ce949eb8"
	],
	"./account/components/AutomationDetailModal": [
		"e554",
		"chunk-1ae4ad87"
	],
	"./account/components/AutomationDetailModal.vue": [
		"e554",
		"chunk-1ae4ad87"
	],
	"./account/components/CampaignDetailModal": [
		"f973",
		"chunk-ac5b0e6e"
	],
	"./account/components/CampaignDetailModal.vue": [
		"f973",
		"chunk-ac5b0e6e"
	],
	"./account/components/CompanyForm": [
		"19d8",
		"chunk-2d0ac972"
	],
	"./account/components/CompanyForm.vue": [
		"19d8",
		"chunk-2d0ac972"
	],
	"./account/components/CompanyKeysForm": [
		"4fbd",
		"chunk-2d0ccf6a"
	],
	"./account/components/CompanyKeysForm.vue": [
		"4fbd",
		"chunk-2d0ccf6a"
	],
	"./account/components/CreateTextOffer": [
		"94a0",
		"chunk-cc93f33a"
	],
	"./account/components/CreateTextOffer.vue": [
		"94a0",
		"chunk-cc93f33a"
	],
	"./account/components/LayoutBanner": [
		"0800",
		"chunk-67dc4936"
	],
	"./account/components/LayoutBanner.vue": [
		"0800",
		"chunk-67dc4936"
	],
	"./account/components/LayoutColors": [
		"d6bc",
		"chunk-3ec39490"
	],
	"./account/components/LayoutColors.vue": [
		"d6bc",
		"chunk-3ec39490"
	],
	"./account/components/LayoutForm": [
		"30d7",
		"chunk-2d0b9066"
	],
	"./account/components/LayoutForm.vue": [
		"30d7",
		"chunk-2d0b9066"
	],
	"./account/components/LayoutLogo": [
		"c53e",
		"chunk-5b131ac6"
	],
	"./account/components/LayoutLogo.vue": [
		"c53e",
		"chunk-5b131ac6"
	],
	"./account/components/LayoutOptions": [
		"9219",
		"chunk-4263e3aa"
	],
	"./account/components/LayoutOptions.vue": [
		"9219",
		"chunk-4263e3aa"
	],
	"./account/components/LayoutSocialMedia": [
		"7208",
		"chunk-c2e63048"
	],
	"./account/components/LayoutSocialMedia.vue": [
		"7208",
		"chunk-c2e63048"
	],
	"./account/components/MetaInfo": [
		"36ba",
		"chunk-7a925602"
	],
	"./account/components/MetaInfo.vue": [
		"36ba",
		"chunk-7a925602"
	],
	"./account/components/ModalBanner": [
		"2d2d",
		"chunk-190dc72c"
	],
	"./account/components/ModalBanner.vue": [
		"2d2d",
		"chunk-190dc72c"
	],
	"./account/components/ModalFavicon": [
		"a986",
		"chunk-14f8a607"
	],
	"./account/components/ModalFavicon.vue": [
		"a986",
		"chunk-14f8a607"
	],
	"./account/components/ModalLogo": [
		"264e",
		"chunk-3826709a"
	],
	"./account/components/ModalLogo.vue": [
		"264e",
		"chunk-3826709a"
	],
	"./account/components/NewAutomation": [
		"4f56",
		"chunk-a875791e"
	],
	"./account/components/NewAutomation.vue": [
		"4f56",
		"chunk-a875791e"
	],
	"./account/components/NewCampaign": [
		"cb63",
		"chunk-590be88c"
	],
	"./account/components/NewCampaign.vue": [
		"cb63",
		"chunk-590be88c"
	],
	"./account/components/NewReward": [
		"9179",
		"chunk-1f726fdc"
	],
	"./account/components/NewReward.vue": [
		"9179",
		"chunk-1f726fdc"
	],
	"./account/components/NewSmsMarketing": [
		"6c52",
		"chunk-531035d4"
	],
	"./account/components/NewSmsMarketing.vue": [
		"6c52",
		"chunk-531035d4"
	],
	"./account/components/PartnerVenueForm": [
		"8e59",
		"chunk-2d0e9787"
	],
	"./account/components/PartnerVenueForm.vue": [
		"8e59",
		"chunk-2d0e9787"
	],
	"./account/components/StoreForm": [
		"d3c8",
		"chunk-2d21e1ba"
	],
	"./account/components/StoreForm.vue": [
		"d3c8",
		"chunk-2d21e1ba"
	],
	"./account/components/StoreImageLayout": [
		"90a1",
		"chunk-ad0994b0"
	],
	"./account/components/StoreImageLayout.vue": [
		"90a1",
		"chunk-ad0994b0"
	],
	"./account/components/StoreImageModal": [
		"3a2d",
		"chunk-5bd3a8c3"
	],
	"./account/components/StoreImageModal.vue": [
		"3a2d",
		"chunk-5bd3a8c3"
	],
	"./account/components/StoreImageSelector": [
		"ccbb",
		"chunk-2d222196"
	],
	"./account/components/StoreImageSelector.vue": [
		"ccbb",
		"chunk-2d222196"
	],
	"./account/components/StorePriceForm": [
		"baab",
		"chunk-2d21a596"
	],
	"./account/components/StorePriceForm.vue": [
		"baab",
		"chunk-2d21a596"
	],
	"./account/components/ViewRewards": [
		"c9f5",
		"chunk-a423ebcc"
	],
	"./account/components/ViewRewards.vue": [
		"c9f5",
		"chunk-a423ebcc"
	],
	"./account/components/ViewTextOffer": [
		"4705",
		"chunk-3c7a7df5"
	],
	"./account/components/ViewTextOffer.vue": [
		"4705",
		"chunk-3c7a7df5"
	],
	"./account/components/index": [
		"ef2b",
		"chunk-5bd3a8c3"
	],
	"./account/components/index.js": [
		"ef2b",
		"chunk-5bd3a8c3"
	],
	"./customers/AddCreditModal": [
		"e973",
		"chunk-e1ea99fe"
	],
	"./customers/AddCreditModal.vue": [
		"e973",
		"chunk-e1ea99fe"
	],
	"./customers/AttachUserCampaign": [
		"ac66",
		"chunk-0d55fda8"
	],
	"./customers/AttachUserCampaign.vue": [
		"ac66",
		"chunk-0d55fda8"
	],
	"./customers/CustomerDetail": [
		"d631",
		"chunk-50bf7bdf"
	],
	"./customers/CustomerDetail.vue": [
		"d631",
		"chunk-50bf7bdf"
	],
	"./customers/Customers": [
		"76f8",
		"chunk-537811f8"
	],
	"./customers/Customers.vue": [
		"76f8",
		"chunk-537811f8"
	],
	"./customers/RegisterNewCustomer": [
		"29b0",
		"chunk-28729fe6"
	],
	"./customers/RegisterNewCustomer.vue": [
		"29b0",
		"chunk-28729fe6"
	],
	"./dashboard/Dashboard": [
		"c557",
		"chunk-5a70483f"
	],
	"./dashboard/Dashboard.vue": [
		"c557",
		"chunk-5a70483f"
	],
	"./dashboard/components": [
		"672e",
		"chunk-c032afc0"
	],
	"./dashboard/components/": [
		"672e",
		"chunk-c032afc0"
	],
	"./dashboard/components/OrderTypes": [
		"5f55",
		"chunk-66ef1fdd"
	],
	"./dashboard/components/OrderTypes.vue": [
		"5f55",
		"chunk-66ef1fdd"
	],
	"./dashboard/components/Puntuality": [
		"77a9",
		"chunk-2d0d7bce"
	],
	"./dashboard/components/Puntuality.vue": [
		"77a9",
		"chunk-2d0d7bce"
	],
	"./dashboard/components/Sales": [
		"b431",
		"chunk-29592ed8"
	],
	"./dashboard/components/Sales.vue": [
		"b431",
		"chunk-29592ed8"
	],
	"./dashboard/components/SalesRejectsLine": [
		"656d",
		"chunk-2d0cfae3"
	],
	"./dashboard/components/SalesRejectsLine.vue": [
		"656d",
		"chunk-2d0cfae3"
	],
	"./dashboard/components/index": [
		"672e",
		"chunk-c032afc0"
	],
	"./dashboard/components/index.js": [
		"672e",
		"chunk-c032afc0"
	],
	"./marketing/Marketing": [
		"1315",
		"chunk-1ef6a8ae"
	],
	"./marketing/Marketing.vue": [
		"1315",
		"chunk-1ef6a8ae"
	],
	"./marketing/components": [
		"1c6a",
		"chunk-4aa8537c"
	],
	"./marketing/components/": [
		"1c6a",
		"chunk-4aa8537c"
	],
	"./marketing/components/OfferForm": [
		"c80e",
		"chunk-2d217a20"
	],
	"./marketing/components/OfferForm.vue": [
		"c80e",
		"chunk-2d217a20"
	],
	"./marketing/components/index": [
		"1c6a",
		"chunk-4aa8537c"
	],
	"./marketing/components/index.js": [
		"1c6a",
		"chunk-4aa8537c"
	],
	"./menus/MenuManagement": [
		"1211",
		"chunk-b8944176"
	],
	"./menus/MenuManagement.vue": [
		"1211",
		"chunk-b8944176"
	],
	"./menus/Menus": [
		"ba60",
		"chunk-87810316"
	],
	"./menus/Menus.vue": [
		"ba60",
		"chunk-87810316"
	],
	"./menus/components": [
		"a66c",
		"chunk-118aa926"
	],
	"./menus/components/": [
		"a66c",
		"chunk-118aa926"
	],
	"./menus/components/MenuCategoryList": [
		"eef9",
		"chunk-15967ffd"
	],
	"./menus/components/MenuCategoryList.vue": [
		"eef9",
		"chunk-15967ffd"
	],
	"./menus/components/MenuMainAddonsList": [
		"2748",
		"chunk-2822adb4"
	],
	"./menus/components/MenuMainAddonsList.vue": [
		"2748",
		"chunk-2822adb4"
	],
	"./menus/components/MenuMainOptionsAddonsList": [
		"9a49",
		"chunk-fe1f7e5e"
	],
	"./menus/components/MenuMainOptionsAddonsList.vue": [
		"9a49",
		"chunk-fe1f7e5e"
	],
	"./menus/components/MenuManagementMainAddonsList": [
		"14e6",
		"chunk-28ed29d0"
	],
	"./menus/components/MenuManagementMainAddonsList.vue": [
		"14e6",
		"chunk-28ed29d0"
	],
	"./menus/components/MenuManagementOptionAddonList": [
		"4303",
		"chunk-36ba18cd"
	],
	"./menus/components/MenuManagementOptionAddonList.vue": [
		"4303",
		"chunk-36ba18cd"
	],
	"./menus/components/MenuManagementProductDetails": [
		"d4d8",
		"chunk-042af0cc"
	],
	"./menus/components/MenuManagementProductDetails.vue": [
		"d4d8",
		"chunk-042af0cc"
	],
	"./menus/components/MenuManagementProductList": [
		"ca8e",
		"chunk-126c1baa"
	],
	"./menus/components/MenuManagementProductList.vue": [
		"ca8e",
		"chunk-126c1baa"
	],
	"./menus/components/MenuModalImage": [
		"d723",
		"chunk-042e86d8"
	],
	"./menus/components/MenuModalImage.vue": [
		"d723",
		"chunk-042e86d8"
	],
	"./menus/components/MenuOptionsAddonsList": [
		"63f0",
		"chunk-1e82e29e"
	],
	"./menus/components/MenuOptionsAddonsList.vue": [
		"63f0",
		"chunk-1e82e29e"
	],
	"./menus/components/MenuProductDetails": [
		"8459",
		"chunk-7fbe3088"
	],
	"./menus/components/MenuProductDetails.vue": [
		"8459",
		"chunk-7fbe3088"
	],
	"./menus/components/MenuProductsList": [
		"68b7",
		"chunk-2645c56e"
	],
	"./menus/components/MenuProductsList.vue": [
		"68b7",
		"chunk-2645c56e"
	],
	"./menus/components/index": [
		"a66c",
		"chunk-118aa926"
	],
	"./menus/components/index.js": [
		"a66c",
		"chunk-118aa926"
	],
	"./menus/data/sections": [
		"e96a",
		"chunk-2d226755"
	],
	"./menus/data/sections.js": [
		"e96a",
		"chunk-2d226755"
	],
	"./menus/subcomponents": [
		"4a4e",
		"chunk-67dbb2f7"
	],
	"./menus/subcomponents/": [
		"4a4e",
		"chunk-67dbb2f7"
	],
	"./menus/subcomponents/AddonAttachOptionList": [
		"56f2",
		"chunk-30697902"
	],
	"./menus/subcomponents/AddonAttachOptionList.vue": [
		"56f2",
		"chunk-30697902"
	],
	"./menus/subcomponents/AddonForm": [
		"8bb9",
		"chunk-2d0e91b7"
	],
	"./menus/subcomponents/AddonForm.vue": [
		"8bb9",
		"chunk-2d0e91b7"
	],
	"./menus/subcomponents/AddonProductForm": [
		"7bba",
		"chunk-439cde0e"
	],
	"./menus/subcomponents/AddonProductForm.vue": [
		"7bba",
		"chunk-439cde0e"
	],
	"./menus/subcomponents/AddonsProduct": [
		"e325",
		"chunk-64e9f822"
	],
	"./menus/subcomponents/AddonsProduct.vue": [
		"e325",
		"chunk-64e9f822"
	],
	"./menus/subcomponents/CategoryForm": [
		"365a",
		"chunk-2d0ba165"
	],
	"./menus/subcomponents/CategoryForm.vue": [
		"365a",
		"chunk-2d0ba165"
	],
	"./menus/subcomponents/MainAddonAttachOption": [
		"c4d7",
		"chunk-0e86d96b"
	],
	"./menus/subcomponents/MainAddonAttachOption.vue": [
		"c4d7",
		"chunk-0e86d96b"
	],
	"./menus/subcomponents/MainAddonForm": [
		"d5f7",
		"chunk-2d21e998"
	],
	"./menus/subcomponents/MainAddonForm.vue": [
		"d5f7",
		"chunk-2d21e998"
	],
	"./menus/subcomponents/MainAddonFormX": [
		"0689",
		"chunk-2d0a447d"
	],
	"./menus/subcomponents/MainAddonFormX.vue": [
		"0689",
		"chunk-2d0a447d"
	],
	"./menus/subcomponents/ProductVariationForm": [
		"c1e5",
		"chunk-1bab56ba"
	],
	"./menus/subcomponents/ProductVariationForm.vue": [
		"c1e5",
		"chunk-1bab56ba"
	],
	"./menus/subcomponents/VariationsProduct": [
		"e119",
		"chunk-a1dbc34a"
	],
	"./menus/subcomponents/VariationsProduct.vue": [
		"e119",
		"chunk-a1dbc34a"
	],
	"./menus/subcomponents/index": [
		"4a4e",
		"chunk-67dbb2f7"
	],
	"./menus/subcomponents/index.js": [
		"4a4e",
		"chunk-67dbb2f7"
	],
	"./orders/Orders": [
		"47a7",
		"chunk-ec4a6680"
	],
	"./orders/Orders.vue": [
		"47a7",
		"chunk-ec4a6680"
	],
	"./orders/components": [
		"969c",
		"chunk-17668e6a"
	],
	"./orders/components/": [
		"969c",
		"chunk-17668e6a"
	],
	"./orders/components/InProgress": [
		"8afa",
		"chunk-8ee764f8"
	],
	"./orders/components/InProgress.vue": [
		"8afa",
		"chunk-8ee764f8"
	],
	"./orders/components/NewOrders": [
		"cc8c",
		"chunk-6ab2b44d"
	],
	"./orders/components/NewOrders.vue": [
		"cc8c",
		"chunk-6ab2b44d"
	],
	"./orders/components/OrderDetails": [
		"60b7",
		"chunk-3cfb649a"
	],
	"./orders/components/OrderDetails.vue": [
		"60b7",
		"chunk-3cfb649a"
	],
	"./orders/components/ReadyForPickup": [
		"a8ce",
		"chunk-78e63e65"
	],
	"./orders/components/ReadyForPickup.vue": [
		"a8ce",
		"chunk-78e63e65"
	],
	"./orders/components/index": [
		"969c",
		"chunk-17668e6a"
	],
	"./orders/components/index.js": [
		"969c",
		"chunk-17668e6a"
	],
	"./orders/subcomponents": [
		"2f4a",
		"chunk-6ed0d1bd"
	],
	"./orders/subcomponents/": [
		"2f4a",
		"chunk-6ed0d1bd"
	],
	"./orders/subcomponents/ExtraTime": [
		"7c00",
		"chunk-39c1d306"
	],
	"./orders/subcomponents/ExtraTime.vue": [
		"7c00",
		"chunk-39c1d306"
	],
	"./orders/subcomponents/NotifyBeforeTime": [
		"631e",
		"chunk-0eece320"
	],
	"./orders/subcomponents/NotifyBeforeTime.vue": [
		"631e",
		"chunk-0eece320"
	],
	"./orders/subcomponents/ScheduledOrders": [
		"402b",
		"chunk-2d0bfee2"
	],
	"./orders/subcomponents/ScheduledOrders.vue": [
		"402b",
		"chunk-2d0bfee2"
	],
	"./orders/subcomponents/TicketPrint": [
		"f2d0",
		"chunk-6cf09d46"
	],
	"./orders/subcomponents/TicketPrint.vue": [
		"f2d0",
		"chunk-6cf09d46"
	],
	"./orders/subcomponents/index": [
		"2f4a",
		"chunk-6ed0d1bd"
	],
	"./orders/subcomponents/index.js": [
		"2f4a",
		"chunk-6ed0d1bd"
	],
	"./ordershistory/OrdersHistory": [
		"fa91",
		"chunk-a2ed68fa"
	],
	"./ordershistory/OrdersHistory.vue": [
		"fa91",
		"chunk-a2ed68fa"
	],
	"./ordershistory/components": [
		"8bd2",
		"chunk-af4fa78a"
	],
	"./ordershistory/components/": [
		"8bd2",
		"chunk-af4fa78a"
	],
	"./ordershistory/components/ExcelExportOrdersHistory": [
		"22ed",
		"chunk-93915526"
	],
	"./ordershistory/components/ExcelExportOrdersHistory.vue": [
		"22ed",
		"chunk-93915526"
	],
	"./ordershistory/components/RefundForm": [
		"2f2d",
		"chunk-2d0be0dc"
	],
	"./ordershistory/components/RefundForm.vue": [
		"2f2d",
		"chunk-2d0be0dc"
	],
	"./ordershistory/components/index": [
		"8bd2",
		"chunk-af4fa78a"
	],
	"./ordershistory/components/index.js": [
		"8bd2",
		"chunk-af4fa78a"
	],
	"./ordershistory/data/reasons-refund": [
		"8ba4",
		"chunk-2d0e9193"
	],
	"./ordershistory/data/reasons-refund.js": [
		"8ba4",
		"chunk-2d0e9193"
	],
	"./qr-code/QRPDFView": [
		"c0cc",
		"chunk-4c31d07a"
	],
	"./qr-code/QRPDFView.vue": [
		"c0cc",
		"chunk-4c31d07a"
	],
	"./qr-code/QRPageView": [
		"3732",
		"chunk-2d0ba4b9"
	],
	"./qr-code/QRPageView.vue": [
		"3732",
		"chunk-2d0ba4b9"
	],
	"./qr-code/QrCodes": [
		"5733",
		"chunk-5f43ddb0"
	],
	"./qr-code/QrCodes.vue": [
		"5733",
		"chunk-5f43ddb0"
	],
	"./refunds/Refunds": [
		"4682",
		"chunk-2d0c15f2"
	],
	"./refunds/Refunds.vue": [
		"4682",
		"chunk-2d0c15f2"
	],
	"./store/StoreDetails": [
		"3cdc",
		"chunk-6428818e"
	],
	"./store/StoreDetails.vue": [
		"3cdc",
		"chunk-6428818e"
	],
	"./store/components": [
		"1c39",
		"chunk-634f6250"
	],
	"./store/components/": [
		"1c39",
		"chunk-634f6250"
	],
	"./store/components/StoreConfigs": [
		"b953",
		"chunk-0931271f"
	],
	"./store/components/StoreConfigs.vue": [
		"b953",
		"chunk-0931271f"
	],
	"./store/components/StoreDeliveryHours": [
		"7e46",
		"chunk-1575e680"
	],
	"./store/components/StoreDeliveryHours.vue": [
		"7e46",
		"chunk-1575e680"
	],
	"./store/components/StoreOpeningHours": [
		"4755",
		"chunk-2342d52f"
	],
	"./store/components/StoreOpeningHours.vue": [
		"4755",
		"chunk-2342d52f"
	],
	"./store/components/StoreStatus": [
		"0865",
		"chunk-efbd145c"
	],
	"./store/components/StoreStatus.vue": [
		"0865",
		"chunk-efbd145c"
	],
	"./store/components/index": [
		"1c39",
		"chunk-634f6250"
	],
	"./store/components/index.js": [
		"1c39",
		"chunk-634f6250"
	],
	"./store/data/reasons-offline-store": [
		"83cd",
		"chunk-2d0de192"
	],
	"./store/data/reasons-offline-store.js": [
		"83cd",
		"chunk-2d0de192"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "ef0c";
module.exports = webpackAsyncContext;